import { render, staticRenderFns } from "./TaxReturnYearly.vue?vue&type=template&id=12dcfbff&scoped=true"
import script from "./TaxReturnYearly.vue?vue&type=script&lang=js"
export * from "./TaxReturnYearly.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnYearly.vue?vue&type=style&index=0&id=12dcfbff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dcfbff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12dcfbff')) {
      api.createRecord('12dcfbff', component.options)
    } else {
      api.reload('12dcfbff', component.options)
    }
    module.hot.accept("./TaxReturnYearly.vue?vue&type=template&id=12dcfbff&scoped=true", function () {
      api.rerender('12dcfbff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnYearly.vue"
export default component.exports